// extracted by mini-css-extract-plugin
export default {"linkAnchor":"InfoLanding_linkAnchor__PzGDL","links":"InfoLanding_links__1iaj6","circleText":"InfoLanding_circleText__NUURE","linkText":"InfoLanding_linkText__ShkgK"};